import React from "react";

export function Skeleton({ className = "", style }) {
  return <div className={`gl-skeleton ${className}`} style={style} aria-hidden />;
}

export function SkeletonCard({ count = 1 }) {
  return (
    <div className="gl-skeleton-kpi-grid">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="gl-skeleton-card" />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 8, columns = 5 }) {
  return (
    <div className="rounded-2xl border border-outline-variant/30 overflow-hidden p-3">
      <Skeleton className="gl-skeleton-row" style={{ width: "30%", marginBottom: 16 }} />
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3 mb-2">
          {Array.from({ length: columns }).map((_, c) => (
            <Skeleton key={c} className="gl-skeleton-row flex-1" style={{ marginBottom: 0 }} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonChart({ count = 1 }) {
  return (
    <div className={count > 1 ? "gl-skeleton-chart-grid" : undefined}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="gl-skeleton-chart" />
      ))}
    </div>
  );
}

export function SkeletonForm({ fields = 4 }) {
  return (
    <div className="max-w-md">
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i} className="mb-4">
          <Skeleton style={{ width: "28%", height: 12, marginBottom: 8 }} />
          <Skeleton className="gl-skeleton-input" />
        </div>
      ))}
      <Skeleton style={{ width: 120, height: 40, borderRadius: 10 }} />
    </div>
  );
}

export function SkeletonList({ items = 6 }) {
  return (
    <div>
      {Array.from({ length: items }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 mb-3">
          <Skeleton style={{ width: 40, height: 40, borderRadius: "50%" }} />
          <div className="flex-1">
            <Skeleton style={{ height: 14, width: "60%", marginBottom: 6 }} />
            <Skeleton style={{ height: 10, width: "40%" }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div>
      <SkeletonCard count={6} />
      <div className="mt-4">
        <SkeletonChart count={2} />
      </div>
      <div className="mt-4">
        <SkeletonTable rows={6} columns={4} />
      </div>
    </div>
  );
}

export default Skeleton;
